import { forwardRef, type ReactNode, type Ref } from 'react';
import clsx from 'clsx';
import { Paragraph, Heading } from '@hungryroot/ramen';
import styles from './ToggleFour.module.css';
import layoutStyles from '../../../Page/layout.module.css';

interface Props {
  testid?: string;
  tagId: number;
  tagName: string;
  likeDislike?: ReactNode;
  imgSrc: string | null;
  remark?: string | null;
  active?: boolean;
  style?: Record<string, unknown>;
  textWrapperClass?: string;
}

export const ToggleFour = forwardRef(
  (props: Props, ref: Ref<HTMLDivElement>) => {
    const {
      testid,
      tagId,
      tagName,
      likeDislike,
      imgSrc,
      remark,
      active,
      style,
      textWrapperClass,
    } = props;

    return (
      <div
        data-testid={testid}
        key={tagId}
        ref={ref}
        className={`
          ${active === true ? styles.active : styles.toggle}
          ${layoutStyles['slide-in']}
          ${likeDislike ? '' : styles.hover}
        `}
        data-active-state={active}
        style={style}
      >
        <img
          src={imgSrc ? imgSrc : `/public/img/quiz/placeholder-image.png`}
          alt={tagName}
          className={likeDislike ? '' : styles.pointer}
        />
        <div
          className={clsx(
            {
              [styles['text-wrapper-with-binary']]: likeDislike,
              [styles['text-wrapper-with-pointer']]: !likeDislike,
            },
            textWrapperClass
          )}
        >
          <Heading variant="H6">{tagName}</Heading>
          {remark ? <Paragraph>{remark}</Paragraph> : null}
        </div>
        <div className={styles['like-dislike-wrapper']}>{likeDislike}</div>
      </div>
    );
  }
);
